import LeaEditTable from "./LeaEditTable.vue";

export default LeaEditTable;
